/**
 * 이력서 관련 공통 함수들
 */

/**
 * 알림 메시지 표시 함수들
 */
export const notification = {
  /**
   * 성공 메시지 표시
   * @param {string} message - 표시할 메시지 (기본값: '저장되었습니다.')
   */
  success: (message = '저장되었습니다.') => {
    alert(message);
  },

  /**
   * 오류 메시지 표시
   * @param {string} message - 표시할 오류 메시지
   */
  error: (message) => {
    alert(message);
  },
};

/**
 * API 응답 처리 공통 함수들
 */
export const apiHandler = {
  /**
   * 저장 성공 처리
   * @param {Object} response - API 응답 객체
   * @param {Function} onSuccess - 성공 시 실행할 콜백 함수
   */
  handleSaveSuccess: (response, onSuccess) => {
    if (response && response.data && response.data.success === 'U') {
      notification.success();
      if (onSuccess) onSuccess(response);
    } else {
      notification.error('저장 처리 중 오류가 발생했습니다.');
    }
  },

  /**
   * API 에러 처리
   * @param {Object} error - 에러 객체
   */
  handleError: (error) => {
    let errorMessage = '처리 중 오류가 발생했습니다.';
    
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    notification.error(errorMessage);
    console.error('API Error:', error);
  },
};

/**
 * DB 컬럼 바이트 길이 제한 (DB 문자셋 UTF-8 → 한글 1자 = 3바이트)
 */
export const byteUtil = {
  /**
   * UTF-8 바이트 길이 계산
   * @param {string} str - 대상 문자열
   */
  getByteLength: (str) => {
    let size = 0;
    for (const ch of (str || '')) {
      const code = ch.codePointAt(0);
      if (code <= 0x7f) size += 1;
      else if (code <= 0x7ff) size += 2;
      else if (code <= 0xffff) size += 3;
      else size += 4;
    }
    return size;
  },

  /**
   * 최대 바이트 이내로 자르기
   * @param {string} value - 대상 문자열
   * @param {number} maxBytes - 최대 바이트
   */
  trimToMaxBytes: (value, maxBytes) => {
    let bytes = 0;
    let result = '';
    for (const ch of (value || '')) {
      const size = byteUtil.getByteLength(ch);
      if (bytes + size > maxBytes) break;
      bytes += size;
      result += ch;
    }
    return result;
  },
};

/**
 * 입력 바이트 제한 mixin
 * 사용: @input="limitBytes($event, 대상객체, '필드명', 최대바이트, '항목명'[, 안내글자수])"
 * 안내글자수 생략 시 한글 기준(최대바이트 / 3)으로 안내
 */
export const byteLimitMixin = {
  methods: {
    limitBytes(event, target, key, maxBytes, label, maxChars) {
      // 한글 조합 중에는 건너뛰고 조합 완료(compositionend → input) 시점에 검사
      if (event.isComposing) return;
      const value = event.target.value || '';
      const trimmed = byteUtil.trimToMaxBytes(value, maxBytes);
      if (trimmed !== value) {
        target[key] = trimmed;
        event.target.value = trimmed;
        const chars = maxChars !== undefined ? maxChars : Math.floor(maxBytes / 3);
        alert(`${label}: 최대 ${chars}글자\n초과된 내용은 잘렸습니다.`);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/main/resume/resume-common.js